export default class MissingRoleException extends Error {
  constructor(...args) {
    super(...args);
    this.message = 'user is missing required role(s).';
  }
}
